export enum LocationTypes
{
    'all' = 0,
    'dc' = 100,
    'store' = 200,
    'supplier' = 300,
    'customer' = 500
}